import React from 'react';
import './icon-button.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../icon';
import { Notification } from '../notification';
import { TapText } from './tap-button-text';

const IconButton = props => {
    const {
        iconName,
        type,
        size,
        fontSize,
        isDisabled,
        isLocked,
        isActive,
        onClick,
        withSpacing,
        notifications,
        altText,
        onCanvas,
    } = props;

    const buttonClasses = classNames({
        button: true,
        'button--small': size === 'small',
        'button--medium': size === 'medium',
        'button--margin': withSpacing === true,

        'button--edit': iconName === 'edit',
        'button--tap': iconName === 'tap',

        'button--affirmitive': iconName === 'tick',
        'button--negative': iconName === 'cross',
    });

    const backgroundClasses = classNames({
        'button__icon-background': true,
        'button__icon-background--small': size === 'small',
        'button__icon-background--medium': size === 'medium',

        'button__icon-background--main': type === 'main',
        'button__icon-background--essential': type === 'essential',
        'button__icon-background--settings': type === 'settings',
        'button__icon-background--tap': iconName === 'tap',

        'button__icon-background--locked': isLocked,
        'button__icon-background--active': isActive,

        'button__icon-background--affirmitive': iconName === 'tick',
        'button__icon-background--negative': iconName === 'cross',

        'button__icon-background--edit': iconName === 'edit',
    });

    return (
        <>
            <button
                className={buttonClasses}
                onClick={
                    !isActive
                        ? onCanvas
                            ? e => onClick(e)
                            : () => onClick()
                        : null
                }
                disabled={isDisabled || isLocked}
                aria-label={altText ? altText : iconName}
            >
                {notifications > 0 && !isLocked && (
                    <Notification
                        amountOfNotifications={notifications}
                        size={fontSize}
                    />
                )}
                <div className={backgroundClasses}>
                    {iconName === 'tap' ? (
                        <TapText />
                    ) : iconName === 'stop' ? (
                        <span className="button__icon-square" />
                    ) : (
                        <Icon
                            iconName={!isLocked ? iconName : 'locked'}
                            size={size}
                            isLocked={isLocked}
                            altText={altText}
                        />
                    )}
                </div>
            </button>
        </>
    );
};

IconButton.defaultProps = {
    size: 'large',
    type: 'main',
    fontSize: 'medium',
    isDisabled: false,
    isLocked: false,
    isActive: false,
    withSpacing: false,
    notifications: 0,
};

IconButton.propTypes = {
    iconName: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['main', 'essential', 'settings', 'decision']),
    size: PropTypes.oneOf(['x-small', 'small', 'medium', 'large']),
    fontSize: PropTypes.oneOf(['medium', 'large']),
    isDisabled: PropTypes.bool,
    isLocked: PropTypes.bool,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    withSpacing: PropTypes.bool,
    notifications: PropTypes.number,
    altText: PropTypes.string,
};

export { IconButton };
